import IconCheckmark from '../icons/IconCheckmark';
import { useLang } from '../hooks/useLanguage.js';
import { getImageUrl } from '../helpers/images';

const Hero = function ({ show }) {
    const { getI18n } = useLang();
    const marketing = show?.marketing || {};

    return (
        <div className="fireknife-hero">
            <div className="fireknife-hero__img-box">
                <img
                    className="fireknife-hero__img"
                    src={getImageUrl(getI18n(marketing.primaryImage, marketing.primaryImageI18n))}
                    alt={getI18n(show.title, show.titleI18n)}
                />
            </div>
            <div className="fireknife-hero__content">
                <h1 className="fireknife-hero__title">
                    {getI18n(show.title, show.titleI18n)}
                    {getI18n(show.subtitle, show.subtitleI18n) && (
                        <span className="fireknife-hero__subtitle">
                            {' - '}
                            {getI18n(show.subtitle, show.subtitleI18n)}
                        </span>
                    )}
                </h1>
                {marketing.subheadline && marketing.subheadline !== '' && (
                    <div className="fireknife-hero__desc">
                        {getI18n(marketing.subheadline, marketing.subheadlineI18n)}
                    </div>
                )}
                {marketing.tags && Array.isArray(marketing.tags) && marketing.tags.length > 0 && (
                    <div className="fireknife-hero__badges">
                        {Array.isArray(marketing.tags) &&
                            marketing.tags.map((tag, idx) => (
                                <div className="fireknife-hero__badge" key={idx}>
                                    <IconCheckmark className="fireknife-hero__badge-icon" />
                                    <div className="fireknife-hero__badge-text">
                                        {getI18n(tag, marketing.tagsI18n, idx)}
                                    </div>
                                </div>
                            ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Hero;
